import React from 'react'
import styled from 'styled-components'

const Box = styled.div`
  min-height: 100px;
  width: 100%;
  z-index: 1;
  border: 3px solid rgb(22, 198, 221);
  border-radius: 10px;
  margin: 40px;
  background-color: lightgrey;
  display: flex;
`
const Text = styled.h2`
  word-break: break-word;
  font-size: 1.75rem;
  padding: 10px;
`
const IntroductionBox = ({ children }) => {
  return (
    <Box>
      <Text>{children}</Text>
    </Box>
  )
}
export default IntroductionBox
